import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ReactComponent as Check } from '../../assets/icons/check.svg';

const StepCounterRoot = styled.div`
  font-family: ${(props) => props.theme.primaryFont};
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
`;
const CheckIcon = styled(Check)`
  width: 10px;
  height: 10px;
  position: absolute;
`;

const Step = styled.span<{
  current?: boolean;
  last?: boolean;
  backgroundGreen?: boolean;
}>`
  color: ${(props) =>
    props.current || props.backgroundGreen ? '#ffffff' : '#3C50E0'};
  background: ${(props) =>
    props.current ? '#3C50E0' : props.backgroundGreen ? '#24C952' : '#ffffff'};
  width: 20px;
  height: 20px;
  border: ${(props) =>
    props.backgroundGreen ? '1px solid #24C952' : '1px solid #3c50e0'};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${(props) => (props.last ? 0 : '22px')};
  position: relative;
`;

const Divider = styled.div<{ last?: boolean; backgroundGreen?: boolean }>`
  position: absolute;
  width: 20px;
  height: 2px;
  left: 20px;
  background: ${(props) => (props.backgroundGreen ? '#24C952' : '#3c50e0')};
  display: ${(props) => props.last && 'none'};
`;

interface IBreadCrumb {
  stepsQty: number;
  current: number;
}

const StepCounter: React.FC<IBreadCrumb> = ({ stepsQty, current }) => {
  const steps = useMemo(() => Array.from(Array(stepsQty), (_, i) => i + 1), [
    stepsQty,
  ]);

  return (
    <StepCounterRoot>
      {steps.map((step) => (
        <React.Fragment key={step}>
          <Step
            current={current === step}
            last={step === stepsQty}
            backgroundGreen={step < current}
          >
            {!(step < current) && step}
            <Divider
              last={step === stepsQty}
              backgroundGreen={step < current}
            />
            {step < current && <CheckIcon />}
          </Step>
        </React.Fragment>
      ))}
    </StepCounterRoot>
  );
};

export default StepCounter;
